export const VERSION = "0.0.78-alpha.6"
